import { CONTROL_EVIDENCE_LABELS } from './labels'

export const NoEvidence = () => (
  <div className='flex h-full items-center leading-loose'>{CONTROL_EVIDENCE_LABELS.noEvidence}</div>
)
